export enum FeatureFlagsRoutes {
  /** GET => server-evaluated { [name]: boolean } map for the request's user */
  Evaluate = 'evaluate',
}
